// import React, { useCallback, useEffect, useState } from 'react';
// import { Link, useParams } from 'react-router-dom';
// import {
//   ArrowLeft,
//   Download,
//   FileText,
//   RefreshCw,
//   Save,
//   Sparkles,
//   Wallet,
// } from 'lucide-react';
// import api from '../../services/api';
// import {
//   downloadBlob,
//   filenameFromContentDisposition,
// } from '../../utils/download';
// import LoadingSpinner from '../common/LoadingSpinner';
// import { toast } from 'react-toastify';

// const defaultFilters = () => ({
//   month: new Date().getMonth() + 1,
//   year: new Date().getFullYear(),
// });

// /** Must match backend payrollCalculator ADDITIVE_EARNINGS — excluded from “core sum = attendance gross”. */
// const ADDITIVE_EARNINGS_KEYS = ['bonus', 'mealAllowance'];

// const PayrollEmployeeDetail = ({ basePath = '/admin/payroll' }) => {
//   const { employeeId } = useParams();
//   const [filters, setFilters] = useState(defaultFilters);
//   const [summary, setSummary] = useState(null);
//   const [payslips, setPayslips] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [savingProfile, setSavingProfile] = useState(false);
//   const [generating, setGenerating] = useState(false);
//   const [profileForm, setProfileForm] = useState({
//     pan: '',
//     uan: '',
//     esiNumber: '',
//     pfNumber: '',
//     department: '',
//     workLocation: '',
//     bankName: '',
//     bankAccountNumber: '',
//     bankIfsc: '',
//     pfContribution: true,
//     esiApplicable: false,
//     payslipTaxEmployeeNote: '',
//   });
//   const [splitForm, setSplitForm] = useState({
//     earnings: {
//       basic: 0,
//       hra: 0,
//       specialAllowance: 0,
//       lta: 0,
//       itAllowance: 0,
//       mealAllowance: 0,
//       bonus: 0,
//     },
//     deductions: {
//       pfEmployee: 0,
//       professionalTax: 0,
//       esiEmployee: 0,
//       incomeTax: 0,
//       labourWelfareFund: 0,
//     },
//   });
//   const [savingSplit, setSavingSplit] = useState(false);
//   const [savingCompensation, setSavingCompensation] = useState(false);
//   const [debugOpen, setDebugOpen] = useState(false);
//   const [compensationForm, setCompensationForm] = useState({
//     ctcBasic: 0,
//     ctcHRA: 0,
//     ctcSpecialAllowance: 0,
//     ctcTravelAllowance: 0,
//     ctcITAllowance: 0,
//   });

//   const fetchSummary = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res = await api.get(
//         `/admin/payroll/employee/${employeeId}/summary?month=${filters.month}&year=${filters.year}`,
//       );
//       setSummary(res.data);
//       const e = res.data.employee;
//       if (e) {
//         setCompensationForm({
//           ctcBasic: Number(e.ctcBasic) || 0,
//           ctcHRA: Number(e.ctcHRA) || 0,
//           ctcSpecialAllowance: Number(e.ctcSpecialAllowance) || 0,
//           ctcTravelAllowance: Number(e.ctcTravelAllowance) || 0,
//           ctcITAllowance: Number(e.ctcITAllowance) || 0,
//         });
//       }
//       const p = res.data.employee?.payrollProfile || {};
//       setProfileForm({
//         pan: p.pan || '',
//         uan: p.uan || '',
//         esiNumber: p.esiNumber || '',
//         pfNumber: p.pfNumber || '',
//         department: p.department || '',
//         workLocation: p.workLocation || '',
//         bankName: p.bankName || '',
//         bankAccountNumber: p.bankAccountNumber || '',
//         bankIfsc: p.bankIfsc || '',
//         pfContribution: p.pfContribution !== false,
//         esiApplicable: !!p.esiApplicable,
//         payslipTaxEmployeeNote: p.payslipTaxEmployeeNote || '',
//       });
//       const c = res.data.calculation;
//       if (c?.earnings && c?.deductions) {
//         setSplitForm({
//           earnings: {
//             basic: Number(c.earnings.basic) || 0,
//             hra: Number(c.earnings.hra) || 0,
//             specialAllowance: Number(c.earnings.specialAllowance) || 0,
//             lta: Number(c.earnings.lta) || 0,
//             itAllowance:
//               Number(c.earnings.itAllowance ?? c.earnings.telephoneInternet) || 0,
//             mealAllowance: Number(c.earnings.mealAllowance) || 0,
//             bonus: Number(c.earnings.bonus) || 0,
//           },
//           deductions: {
//             pfEmployee: Number(c.deductions.pfEmployee) || 0,
//             professionalTax: Number(c.deductions.professionalTax) || 0,
//             esiEmployee: Number(c.deductions.esiEmployee) || 0,
//             incomeTax: Number(c.deductions.incomeTax) || 0,
//             labourWelfareFund: Number(c.deductions.labourWelfareFund) || 0,
//           },
//         });
//       }
//     } catch (e) {
//       console.error(e);
//       toast.error(e.response?.data?.message || 'Failed to load payroll summary');
//       setSummary(null);
//     } finally {
//       setLoading(false);
//     }
//   }, [employeeId, filters.month, filters.year]);

//   const fetchPayslips = useCallback(async () => {
//     try {
//       const res = await api.get(`/admin/payroll/employee/${employeeId}/payslips`);
//       setPayslips(res.data.payslips || []);
//     } catch (e) {
//       console.error(e);
//     }
//   }, [employeeId]);

//   useEffect(() => {
//     fetchSummary();
//   }, [fetchSummary]);

//   useEffect(() => {
//     fetchPayslips();
//   }, [fetchPayslips]);

//   const updateCompensation = (key, raw) => {
//     const n = parseFloat(raw);
//     setCompensationForm((prev) => ({
//       ...prev,
//       [key]: Number.isFinite(n) ? n : 0,
//     }));
//   };

//   const saveCompensation = async (e) => {
//     e.preventDefault();
//     setSavingCompensation(true);
//     try {
//       await api.put(`/admin/payroll/employee/${employeeId}/compensation`, compensationForm);
//       toast.success('Compensation & CTC saved');
//       await fetchSummary();
//     } catch (err) {
//       toast.error(err.response?.data?.message || 'Could not save compensation');
//     } finally {
//       setSavingCompensation(false);
//     }
//   };

//   const saveProfile = async (e) => {
//     e.preventDefault();
//     setSavingProfile(true);
//     try {
//       await api.put(`/admin/payroll/employee/${employeeId}/profile`, profileForm);
//       toast.success('Payroll profile saved');
//       fetchSummary();
//     } catch (err) {
//       toast.error(err.response?.data?.message || 'Save failed');
//     } finally {
//       setSavingProfile(false);
//     }
//   };

//   const saveMonthSplit = async () => {
//     setSavingSplit(true);
//     try {
//       const { arrears, ...earningsWithoutArrears } = splitForm.earnings;
//       await api.put(`/admin/payroll/employee/${employeeId}/month-split`, {
//         month: filters.month,
//         year: filters.year,
//         earnings: earningsWithoutArrears,
//         deductions: splitForm.deductions,
//       });
//       toast.success('Earnings & deductions saved for this month');
//       await fetchSummary();
//     } catch (err) {
//       toast.error(err.response?.data?.message || 'Could not save split');
//     } finally {
//       setSavingSplit(false);
//     }
//   };

//   const clearMonthSplit = async () => {
//     try {
//       await api.delete(
//         `/admin/payroll/employee/${employeeId}/month-split?month=${filters.month}&year=${filters.year}`,
//       );
//       toast.success('Cleared saved split — defaults restored');
//       await fetchSummary();
//     } catch (err) {
//       toast.error(err.response?.data?.message || 'Could not clear');
//     }
//   };

//   const updateEarning = (key, raw) => {
//     const n = parseFloat(raw);
//     setSplitForm((prev) => ({
//       ...prev,
//       earnings: { ...prev.earnings, [key]: Number.isFinite(n) ? n : 0 },
//     }));
//   };

//   const updateDeduction = (key, raw) => {
//     const n = parseFloat(raw);
//     setSplitForm((prev) => ({
//       ...prev,
//       deductions: { ...prev.deductions, [key]: Number.isFinite(n) ? n : 0 },
//     }));
//   };

//   const generatePayslip = async () => {
//     if (!earningsMatch) {
//       toast.error(
//         'Core earnings (basic, HRA, allowances — not bonus/meal) must match attendance gross. Fix the red row in Preview or use Refresh.',
//       );
//       return;
//     }
//     setGenerating(true);
//     try {
//       const { arrears: _omitArrears, ...earningsForSave } = splitForm.earnings;
//       await api.put(`/admin/payroll/employee/${employeeId}/month-split`, {
//         month: filters.month,
//         year: filters.year,
//         earnings: earningsForSave,
//         deductions: splitForm.deductions,
//       });
//       await api.post(`/admin/payroll/employee/${employeeId}/generate`, {
//         month: filters.month,
//         year: filters.year,
//       });
//       toast.success('Month split saved and payslip generated');
//       await fetchPayslips();
//       await fetchSummary();
//     } catch (err) {
//       toast.error(err.response?.data?.message || 'Generation failed');
//     } finally {
//       setGenerating(false);
//     }
//   };

//   const downloadPdf = async (payslipId) => {
//     try {
//       const res = await api.get(`/admin/payroll/payslip/${payslipId}/pdf`, {
//         responseType: 'blob',
//       });
//       const fname = filenameFromContentDisposition(
//         res,
//         `payslip_${payslipId}.pdf`,
//       );
//       downloadBlob(new Blob([res.data], { type: 'application/pdf' }), fname);
//     } catch (err) {
//       toast.error('Could not download PDF');
//     }
//   };

//   const calc = summary?.calculation;
//   const emp = summary?.employee;

//   const earningsEntries = Object.entries(splitForm.earnings || {});
//   const coreEarningsSum = earningsEntries.reduce((s, [k, v]) => {
//     if (ADDITIVE_EARNINGS_KEYS.includes(k)) return s;
//     return s + (Number(v) || 0);
//   }, 0);
//   const additiveEarningsSum = ADDITIVE_EARNINGS_KEYS.reduce(
//     (s, k) => s + (Number(splitForm.earnings?.[k]) || 0),
//     0,
//   );
//   const baseGross = Number(calc?.baseGrossEarnings) || Number(calc?.grossBeforeArrears) || 0;
//   const autoArrears = Number(calc?.arrearsAmount) || Number(calc?.earnings?.arrears) || 0;
//   const arrearsUnits = Number(calc?.arrearsUnits) || 0;
//   const previewGrossTotal = baseGross + autoArrears + additiveEarningsSum;
//   const earningsMatch = Math.abs(coreEarningsSum - baseGross) < 0.05;
//   const deductionsSum = Object.values(splitForm.deductions || {}).reduce(
//     (s, v) => s + (Number(v) || 0),
//     0,
//   );
//   const previewNet = previewGrossTotal - deductionsSum;

//   const monthlyCtcTotal =
//     (Number(compensationForm.ctcBasic) || 0) +
//     (Number(compensationForm.ctcHRA) || 0) +
//     (Number(compensationForm.ctcSpecialAllowance) || 0) +
//     (Number(compensationForm.ctcTravelAllowance) || 0) +
//     (Number(compensationForm.ctcITAllowance) || 0);

//   const ctcFields = [
//     ['ctcBasic', 'Basic'],
//     ['ctcHRA', 'HRA'],
//     ['ctcSpecialAllowance', 'Special allowance'],
//     ['ctcTravelAllowance', 'Travel / LTA'],
//     ['ctcITAllowance', 'IT allowance'],
//   ];

//   return (
//     <div className="space-y-6">
//       <div className="flex items-center gap-3">
//         <Link
//           to={basePath}
//           className="inline-flex items-center text-sm text-primary-600 hover:text-primary-800"
//         >
//           <ArrowLeft className="h-4 w-4 mr-1" />
//           Back to payroll list
//         </Link>
//       </div>

//       {loading && !summary ? (
//         <LoadingSpinner size="lg" className="py-16" />
//       ) : !emp ? (
//         <p className="text-gray-600">Employee not found.</p>
//       ) : (
//         <>
//           <div className="bg-white rounded-lg shadow p-6">
//             <h1 className="text-2xl font-bold text-gray-900">{emp.name}</h1>
//             <p className="text-gray-600 mt-1">
//               {emp.jobTitle} · {emp.employeeId} · {emp.organization}
//             </p>
//           </div>

//           <form
//             onSubmit={saveCompensation}
//             className="bg-white rounded-lg shadow border border-gray-100 p-6 space-y-6"
//           >
//             <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4">
//               <div className="flex gap-3">
//                 <div className="rounded-lg bg-primary-50 p-2.5 h-fit">
//                   <Wallet className="h-6 w-6 text-primary-600" />
//                 </div>
//                 <div>
//                   <h2 className="text-lg font-semibold text-gray-900">Compensation &amp; CTC</h2>
//                   <p className="text-sm text-gray-600 mt-1 max-w-2xl">
//                     Monthly salary is the <strong>sum of CTC components</strong> below. Gross pay for the
//                     selected month is that total × (paid work units ÷ working days in the month). Payslip
//                     lines follow the same mix as your CTC (basic, HRA, etc.).
//                   </p>
//                 </div>
//               </div>
//               <div className="lg:text-right shrink-0 rounded-lg bg-gray-50 px-4 py-3 border border-gray-100">
//                 <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">
//                   Monthly CTC (sum of components)
//                 </p>
//                 <p className="text-2xl font-semibold text-gray-900 tabular-nums">
//                   ₹{monthlyCtcTotal.toLocaleString('en-IN', { maximumFractionDigits: 2 })}
//                 </p>
//               </div>
//             </div>

//             <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
//               {ctcFields.map(([key, label]) => (
//                 <div key={key}>
//                   <label className="block text-sm font-medium text-gray-700">{label}</label>
//                   <div className="mt-1 relative">
//                     <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm">
//                       ₹
//                     </span>
//                     <input
//                       type="number"
//                       step="0.01"
//                       min="0"
//                       className="w-full border border-gray-300 rounded-md pl-8 pr-3 py-2 text-sm focus:ring-primary-500 focus:border-primary-500"
//                       value={compensationForm[key]}
//                       onChange={(ev) => updateCompensation(key, ev.target.value)}
//                     />
//                   </div>
//                 </div>
//               ))}
//             </div>

//             {calc != null && (
//               <div className="rounded-lg bg-slate-50 border border-slate-200 p-4">
//                 <p className="text-sm font-medium text-slate-800">Preview for selected month</p>
//                 <p className="text-xs text-slate-600 mt-1">
//                   Implied daily rate (monthly CTC ÷ working days in that month):{' '}
//                   <span className="font-semibold text-slate-900 tabular-nums">
//                     ₹{Number(calc.payScalePerDay || 0).toLocaleString('en-IN', {
//                       minimumFractionDigits: 2,
//                       maximumFractionDigits: 2,
//                     })}
//                   </span>
//                   {' · '}
//                   Gross before arrears:{' '}
//                   <span className="font-semibold text-slate-900 tabular-nums">
//                     ₹{Number(calc.grossBeforeArrears ?? 0).toLocaleString('en-IN', {
//                       minimumFractionDigits: 2,
//                       maximumFractionDigits: 2,
//                     })}
//                   </span>
//                 </p>
//               </div>
//             )}

//             <div className="flex justify-end pt-2 border-t border-gray-100">
//               <button
//                 type="submit"
//                 disabled={savingCompensation}
//                 className="inline-flex items-center px-5 py-2.5 bg-primary-600 text-white rounded-md text-sm font-medium hover:bg-primary-700 disabled:opacity-50 shadow-sm"
//               >
//                 <Save className="h-4 w-4 mr-2" />
//                 {savingCompensation ? 'Saving…' : 'Save compensation'}
//               </button>
//             </div>
//           </form>

//           <div className="bg-white rounded-lg shadow p-6 flex flex-wrap gap-4 items-end">
//             <div>
//               <label className="block text-sm font-medium text-gray-700">Month</label>
//               <select
//                 value={filters.month}
//                 onChange={(e) =>
//                   setFilters((f) => ({ ...f, month: parseInt(e.target.value, 10) }))
//                 }
//                 className="mt-1 block w-40 px-3 py-2 border border-gray-300 rounded-md"
//               >
//                 {Array.from({ length: 12 }, (_, i) => (
//                   <option key={i + 1} value={i + 1}>
//                     {new Date(0, i).toLocaleString('default', { month: 'long' })}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700">Year</label>
//               <select
//                 value={filters.year}
//                 onChange={(e) =>
//                   setFilters((f) => ({ ...f, year: parseInt(e.target.value, 10) }))
//                 }
//                 className="mt-1 block w-32 px-3 py-2 border border-gray-300 rounded-md"
//               >
//                 {Array.from({ length: 6 }, (_, i) => {
//                   const y = new Date().getFullYear() - 2 + i;
//                   return (
//                     <option key={y} value={y}>
//                       {y}
//                     </option>
//                   );
//                 })}
//               </select>
//             </div>
//             <button
//               type="button"
//               onClick={fetchSummary}
//               className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md text-sm hover:bg-gray-50"
//             >
//               <RefreshCw className="h-4 w-4 mr-2" />
//               Refresh
//             </button>
//             <button
//               type="button"
//               onClick={generatePayslip}
//               disabled={generating}
//               className="inline-flex items-center px-4 py-2 bg-primary-600 text-white rounded-md text-sm hover:bg-primary-700 disabled:opacity-50"
//               title="Saves the current earnings & deductions split, then generates the payslip (bonus/meal are included)."
//             >
//               <Sparkles className="h-4 w-4 mr-2" />
//               {generating ? 'Generating…' : 'Generate / update payslip'}
//             </button>
//             {summary?.existingPayslipId && (
//               <button
//                 type="button"
//                 onClick={() => downloadPdf(summary.existingPayslipId)}
//                 className="inline-flex items-center px-4 py-2 bg-green-600 text-white rounded-md text-sm hover:bg-green-700"
//               >
//                 <Download className="h-4 w-4 mr-2" />
//                 Download PDF (selected month)
//               </button>
//             )}
//           </div>

//           {calc?.overrideWarning && (
//             <div className="bg-red-50 border border-red-200 text-red-800 text-sm rounded-lg p-4">
//               {calc.overrideWarning}
//             </div>
//           )}

//           {calc && (
//             <div className="space-y-6">
//               <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//                 <div className="bg-white rounded-lg shadow p-6">
//                   <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
//                     <FileText className="h-5 w-5 text-primary-600" />
//                     Attendance & pay calculation
//                   </h2>
//                   <dl className="mt-4 space-y-2 text-sm">
//                     <div className="flex justify-between">
//                       <dt className="text-gray-600">Monthly CTC</dt>
//                       <dd className="font-medium">
//                         ₹{monthlyCtcTotal.toLocaleString('en-IN', { maximumFractionDigits: 2 })}
//                       </dd>
//                     </div>
//                     <div className="flex justify-between">
//                       <dt className="text-gray-600">Daily rate</dt>
//                       <dd className="font-medium">
//                         ₹{Number(calc.payScalePerDay || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
//                       </dd>
//                     </div>
//                     <div className="flex justify-between">
//                       <dt className="text-gray-600">Effective work days (period)</dt>
//                       <dd className="font-medium">{calc.effectiveWorkDays ?? '—'}</dd>
//                     </div>
//                     <div className="flex justify-between">
//                       <dt className="text-gray-600">LOP days</dt>
//                       <dd className="font-medium">{calc.lopDays ?? 0}</dd>
//                     </div>
//                     <div className="flex justify-between">
//                       <dt className="text-gray-600">Paid day units</dt>
//                       <dd className="font-medium">{calc.paidUnits}</dd>
//                     </div>
//                     <div className="flex justify-between">
//                       <dt className="text-gray-600">Attendance Gross</dt>
//                       <dd className="font-semibold text-gray-900">
//                         ₹{Number(calc.baseGrossEarnings ?? calc.grossBeforeArrears ?? 0).toLocaleString('en-IN')}
//                       </dd>
//                     </div>
//                     <div className="flex justify-between">
//                       <dt className="text-gray-600">
//                         Arrears (Auto)
//                         {arrearsUnits > 0 && (
//                           <span className="ml-1 text-xs text-gray-400">({arrearsUnits} prior-month unit{arrearsUnits !== 1 ? 's' : ''})</span>
//                         )}
//                       </dt>
//                       <dd className="font-medium text-gray-900">
//                         ₹{autoArrears.toLocaleString('en-IN', { maximumFractionDigits: 2 })}
//                       </dd>
//                     </div>
//                     {Number(autoArrears) > 0 && (
//                       <div className="flex justify-between">
//                         <dt className="text-gray-600">Total Gross (incl. arrears)</dt>
//                         <dd className="font-semibold text-gray-900">
//                           ₹{Number(calc.grossEarnings).toLocaleString('en-IN')}
//                         </dd>
//                       </div>
//                     )}
//                     <div className="flex justify-between">
//                       <dt className="text-gray-600">Net (from split below)</dt>
//                       <dd className="font-semibold text-primary-700">
//                         ₹{Number(calc.netPay).toLocaleString('en-IN')}
//                       </dd>
//                     </div>
//                     <div className="flex justify-between">
//                       <dt className="text-gray-600">Gratuity (indicative)</dt>
//                       <dd className="font-medium">
//                         ₹{Number(calc.gratuityMonthlyAccrual).toLocaleString('en-IN')}
//                       </dd>
//                     </div>
//                   </dl>
//                   <div className="mt-4 pt-4 border-t text-xs text-gray-600 space-y-1">
//                     <p>
//                       Sundays: {calc.dayBreakdownSummary?.sundays} · Holidays:{' '}
//                       {calc.dayBreakdownSummary?.holidays} · Working full:{' '}
//                       {calc.dayBreakdownSummary?.fullPaidWorking} · Half:{' '}
//                       {calc.dayBreakdownSummary?.halfPaidWorking}
//                     </p>
//                     <p>
//                       Paid leave (full/half): {calc.dayBreakdownSummary?.leavePaidFull} /{' '}
//                       {calc.dayBreakdownSummary?.leavePaidHalf} · LWP:{' '}
//                       {calc.dayBreakdownSummary?.leaveWithoutPayFull} /{' '}
//                       {calc.dayBreakdownSummary?.leaveWithoutPayHalf} · Absent:{' '}
//                       {calc.dayBreakdownSummary?.absent}
//                     </p>
//                   </div>
//                 </div>

//                 <div className="bg-white rounded-lg shadow p-6">
//                   <h2 className="text-lg font-semibold text-gray-900">Preview</h2>
//                   <p className="text-sm text-gray-600 mt-2">
//                     Attendance gross:{' '}
//                     <span className="font-mono">₹{baseGross.toLocaleString('en-IN')}</span>
//                     {autoArrears > 0 && (
//                       <>
//                         {' · '}Arrears (auto):{' '}
//                         <span className="font-mono">₹{autoArrears.toLocaleString('en-IN')}</span>
//                       </>
//                     )}
//                     {additiveEarningsSum > 0 && (
//                       <>
//                         {' · '}Bonus / meal:{' '}
//                         <span className="font-mono">₹{additiveEarningsSum.toLocaleString('en-IN')}</span>
//                       </>
//                     )}
//                     {' · '}
//                     <span className="font-semibold text-gray-900">
//                       Preview gross: ₹{previewGrossTotal.toLocaleString('en-IN')}
//                     </span>
//                     .{' '}
//                     {summary?.monthOverride && (
//                       <span className="text-green-700 font-medium">Saved HR split for this month.</span>
//                     )}
//                   </p>
//                   <dl className="mt-4 space-y-2 text-sm">
//                     <div className="flex justify-between">
//                       <dt className="text-gray-600">Core earnings (must match attendance gross)</dt>
//                       <dd className={earningsMatch ? 'font-medium text-green-700' : 'font-medium text-red-600'}>
//                         ₹{coreEarningsSum.toLocaleString('en-IN', { maximumFractionDigits: 2 })}
//                         {!earningsMatch && ` — need ₹${baseGross.toLocaleString('en-IN', { maximumFractionDigits: 2 })}`}
//                       </dd>
//                     </div>
//                     {additiveEarningsSum > 0 && (
//                       <div className="flex justify-between">
//                         <dt className="text-gray-600">Bonus + meal (on top)</dt>
//                         <dd className="font-medium text-gray-800">
//                           ₹{additiveEarningsSum.toLocaleString('en-IN', { maximumFractionDigits: 2 })}
//                         </dd>
//                       </div>
//                     )}
//                     <div className="flex justify-between">
//                       <dt className="text-gray-600">Deductions total</dt>
//                       <dd className="font-medium">₹{deductionsSum.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</dd>
//                     </div>
//                     <div className="flex justify-between border-t pt-2">
//                       <dt className="text-gray-800 font-medium">Preview net (gross − deductions)</dt>
//                       <dd className="font-semibold">₹{previewNet.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</dd>
//                     </div>
//                   </dl>
//                   <p className="text-xs text-gray-500 mt-3">
//                     Employer PF (ref.): ₹{Number(calc.employerPf).toLocaleString('en-IN')} · Employer ESI: ₹
//                     {Number(calc.employerEsi).toLocaleString('en-IN')}
//                   </p>
//                 </div>
//               </div>

//               <div className="bg-white rounded-lg shadow p-6">
//                 <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
//                   <h2 className="text-lg font-semibold text-gray-900">
//                     Earnings & deductions (editable for this month)
//                   </h2>
//                   <div className="flex flex-wrap gap-2">
//                     <button
//                       type="button"
//                       onClick={saveMonthSplit}
//                       disabled={savingSplit || !earningsMatch}
//                       className="inline-flex items-center px-4 py-2 bg-primary-600 text-white rounded-md text-sm hover:bg-primary-700 disabled:opacity-50"
//                     >
//                       <Save className="h-4 w-4 mr-2" />
//                       {savingSplit ? 'Saving…' : 'Save split'}
//                     </button>
//                     <button
//                       type="button"
//                       onClick={clearMonthSplit}
//                       className="px-4 py-2 border border-gray-300 rounded-md text-sm hover:bg-gray-50"
//                     >
//                       Reset to auto
//                     </button>
//                   </div>
//                 </div>
//                 <p className="text-xs text-gray-500 mt-2">
//                   Basic, HRA, and other fixed allowances (above) must add up to the attendance gross. Bonus and meal
//                   allowance are extra on top. Use <strong>Save split</strong> to store, or <strong>Generate payslip</strong>{' '}
//                   to save and generate in one step.
//                 </p>
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
//                   <div>
//                     <h3 className="text-sm font-semibold text-gray-800 mb-3">Earnings</h3>
//                     <div className="space-y-3">
//                       {[
//                         ['basic', 'Basic'],
//                         ['hra', 'HRA'],
//                         ['specialAllowance', 'Special allowance'],
//                         ['lta', 'LTA'],
//                         ['itAllowance', 'IT'],
//                         ['mealAllowance', 'Meal allowance'],
//                       ].map(([key, label]) => (
//                         <div key={key} className="flex items-center gap-2">
//                           <label className="w-44 text-sm text-gray-600 shrink-0">{label}</label>
//                           <input
//                             type="number"
//                             step="0.01"
//                             className="flex-1 border rounded-md px-2 py-1.5 text-sm"
//                             value={splitForm.earnings[key]}
//                             onChange={(e) => updateEarning(key, e.target.value)}
//                           />
//                         </div>
//                       ))}
//                       <div className="rounded-lg border border-amber-200 bg-amber-50/60 px-3 py-3 mt-4 space-y-2">
//                         <div className="flex items-center gap-2">
//                           <label className="w-44 text-sm font-medium text-amber-900 shrink-0">
//                             Bonus
//                           </label>
//                           <input
//                             type="number"
//                             step="0.01"
//                             className="flex-1 border border-amber-200 rounded-md px-2 py-1.5 text-sm bg-white"
//                             value={splitForm.earnings.bonus}
//                             onChange={(e) => updateEarning('bonus', e.target.value)}
//                           />
//                         </div>
//                         <p className="text-xs text-amber-900/80">
//                           Variable by month — not part of fixed CTC split. Enter the amount that applies to this pay
//                           period only.
//                         </p>
//                       </div>
//                       <div className="rounded-lg border border-blue-200 bg-blue-50/60 px-3 py-3 mt-2 space-y-2">
//                         <div className="flex items-center justify-between gap-2">
//                           <div>
//                             <span className="text-sm font-medium text-blue-900">Arrears (Auto)</span>
//                             {arrearsUnits > 0 && (
//                               <span className="ml-2 text-xs text-blue-700">{arrearsUnits} prior-month unit{arrearsUnits !== 1 ? 's' : ''}</span>
//                             )}
//                           </div>
//                           <span className="text-sm font-semibold text-blue-900 tabular-nums">
//                             ₹{autoArrears.toLocaleString('en-IN', { maximumFractionDigits: 2 })}
//                           </span>
//                         </div>
//                         <p className="text-xs text-blue-900/80">
//                           Prior-month paid leaves approved this month — calculated automatically. Not editable.
//                         </p>
//                         {calc?.arrearsDetail?.explanation && (
//                           <p className="text-xs text-blue-800 italic border-t border-blue-200 pt-2">
//                             {calc.arrearsDetail.explanation}
//                           </p>
//                         )}
//                         {calc?.arrearsDetail?.lateApprovedLeaves?.length > 0 && (
//                           <details className="text-xs">
//                             <summary className="cursor-pointer text-blue-700 font-medium select-none">
//                               Audit trail ({calc.arrearsDetail.lateApprovedLeaves.length} leave record{calc.arrearsDetail.lateApprovedLeaves.length !== 1 ? 's' : ''})
//                             </summary>
//                             <ul className="mt-2 space-y-1 text-blue-900/80">
//                               {calc.arrearsDetail.lateApprovedLeaves.map((l, i) => (
//                                 <li key={i} className="border-l-2 border-blue-300 pl-2">
//                                   {l.dates} · {l.type} · {l.reason}
//                                 </li>
//                               ))}
//                             </ul>
//                           </details>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                   <div>
//                     <h3 className="text-sm font-semibold text-gray-800 mb-3">Deductions</h3>
//                     <div className="space-y-3">
//                       {[
//                         ['pfEmployee', 'PF (employee)'],
//                         ['professionalTax', 'Professional tax'],
//                         ['esiEmployee', 'ESI (employee)'],
//                         ['incomeTax', 'Income tax / TDS'],
//                         ['labourWelfareFund', 'Labour welfare fund'],
//                       ].map(([key, label]) => (
//                         <div key={key} className="flex items-center gap-2">
//                           <label className="w-44 text-sm text-gray-600 shrink-0">{label}</label>
//                           <input
//                             type="number"
//                             step="0.01"
//                             className="flex-1 border rounded-md px-2 py-1.5 text-sm"
//                             value={splitForm.deductions[key]}
//                             onChange={(e) => updateDeduction(key, e.target.value)}
//                           />
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {process.env.NODE_ENV !== 'production' && calc.debug && (
//                 <div className="bg-white rounded-lg shadow border border-dashed border-yellow-300 p-6">
//                   <button
//                     type="button"
//                     onClick={() => setDebugOpen((o) => !o)}
//                     className="flex items-center gap-2 text-sm font-semibold text-yellow-800 hover:text-yellow-900"
//                   >
//                     <span>{debugOpen ? '▾' : '▸'}</span>
//                     Payroll Debug (non-production only)
//                   </button>
//                   {debugOpen && (
//                     <dl className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2 text-xs font-mono">
//                       {Object.entries(calc.debug).map(([k, v]) => (
//                         <div key={k} className="flex justify-between gap-2 border-b border-yellow-100 pb-1">
//                           <dt className="text-yellow-900 truncate">{k}</dt>
//                           <dd className="text-yellow-800 font-semibold shrink-0">
//                             {typeof v === 'object' ? JSON.stringify(v) : String(v ?? '—')}
//                           </dd>
//                         </div>
//                       ))}
//                     </dl>
//                   )}
//                 </div>
//               )}
//             </div>
//           )}

//           <form
//             onSubmit={saveProfile}
//             className="bg-white rounded-lg shadow border border-gray-100 p-6 grid grid-cols-1 md:grid-cols-2 gap-4"
//           >
//             <div className="md:col-span-2 space-y-2">
//               <h2 className="text-lg font-semibold text-gray-900">
//                 Payslip &amp; statutory details
//               </h2>
//               <p className="text-sm text-gray-600">
//                 Pre-filled from the employee&apos;s{' '}
//                 <strong>onboarding record</strong> (PAN, PF reference, address city/state) and any{' '}
//                 <strong>payroll fields</strong> already saved. Adjust here only when something changed or was missing —
//                 saving updates both the payroll record and the employee profile where applicable.
//               </p>
//             </div>
//             <div>
//               <label className="block text-sm text-gray-700">Department</label>
//               <input
//                 className="mt-1 w-full border rounded-md px-3 py-2 text-sm"
//                 value={profileForm.department}
//                 onChange={(e) => setProfileForm({ ...profileForm, department: e.target.value })}
//               />
//             </div>
//             <div>
//               <label className="block text-sm text-gray-700">Work location</label>
//               <input
//                 className="mt-1 w-full border rounded-md px-3 py-2 text-sm"
//                 value={profileForm.workLocation}
//                 onChange={(e) => setProfileForm({ ...profileForm, workLocation: e.target.value })}
//               />
//             </div>
//             <div>
//               <label className="block text-sm text-gray-700">PAN</label>
//               <input
//                 className="mt-1 w-full border rounded-md px-3 py-2 text-sm"
//                 value={profileForm.pan}
//                 onChange={(e) => setProfileForm({ ...profileForm, pan: e.target.value })}
//               />
//             </div>
//             <div>
//               <label className="block text-sm text-gray-700">UAN (PF)</label>
//               <input
//                 className="mt-1 w-full border rounded-md px-3 py-2 text-sm"
//                 value={profileForm.uan}
//                 onChange={(e) => setProfileForm({ ...profileForm, uan: e.target.value })}
//               />
//             </div>
//             <div>
//               <label className="block text-sm text-gray-700">PF number</label>
//               <input
//                 className="mt-1 w-full border rounded-md px-3 py-2 text-sm"
//                 value={profileForm.pfNumber}
//                 onChange={(e) => setProfileForm({ ...profileForm, pfNumber: e.target.value })}
//               />
//             </div>
//             <div>
//               <label className="block text-sm text-gray-700">ESI number</label>
//               <input
//                 className="mt-1 w-full border rounded-md px-3 py-2 text-sm"
//                 value={profileForm.esiNumber}
//                 onChange={(e) => setProfileForm({ ...profileForm, esiNumber: e.target.value })}
//               />
//             </div>
//             <div>
//               <label className="block text-sm text-gray-700">Bank name</label>
//               <input
//                 className="mt-1 w-full border rounded-md px-3 py-2 text-sm"
//                 value={profileForm.bankName}
//                 onChange={(e) => setProfileForm({ ...profileForm, bankName: e.target.value })}
//               />
//             </div>
//             <div>
//               <label className="block text-sm text-gray-700">Account number</label>
//               <input
//                 className="mt-1 w-full border rounded-md px-3 py-2 text-sm"
//                 value={profileForm.bankAccountNumber}
//                 onChange={(e) =>
//                   setProfileForm({ ...profileForm, bankAccountNumber: e.target.value })
//                 }
//               />
//             </div>
//             <div>
//               <label className="block text-sm text-gray-700">IFSC</label>
//               <input
//                 className="mt-1 w-full border rounded-md px-3 py-2 text-sm"
//                 value={profileForm.bankIfsc}
//                 onChange={(e) => setProfileForm({ ...profileForm, bankIfsc: e.target.value })}
//               />
//             </div>
//             <div className="flex items-center gap-2 md:col-span-2">
//               <input
//                 id="pf"
//                 type="checkbox"
//                 checked={profileForm.pfContribution}
//                 onChange={(e) =>
//                   setProfileForm({ ...profileForm, pfContribution: e.target.checked })
//                 }
//               />
//               <label htmlFor="pf" className="text-sm text-gray-700">
//                 PF employee contribution applicable
//               </label>
//             </div>
//             <div className="flex items-center gap-2 md:col-span-2">
//               <input
//                 id="esi"
//                 type="checkbox"
//                 checked={profileForm.esiApplicable}
//                 onChange={(e) =>
//                   setProfileForm({ ...profileForm, esiApplicable: e.target.checked })
//                 }
//               />
//               <label htmlFor="esi" className="text-sm text-gray-700">
//                 ESI applicable (gross ≤ ₹21,000 — system uses this flag)
//               </label>
//             </div>
//             <div className="md:col-span-2">
//               <label className="block text-sm font-medium text-gray-700">
//                 Payslip tax-page note (this employee only)
//               </label>
//               <p className="text-xs text-gray-500 mt-1 mb-2">
//                 Shown on the second PDF page only if HR enables the company tax page and enters company-wide
//                 text there. Use for employee-specific tax instructions or references.
//               </p>
//               <textarea
//                 rows={3}
//                 className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
//                 placeholder="Optional — e.g. reference to declared regime or internal payroll case ID"
//                 value={profileForm.payslipTaxEmployeeNote}
//                 onChange={(e) =>
//                   setProfileForm({ ...profileForm, payslipTaxEmployeeNote: e.target.value })
//                 }
//               />
//             </div>
//             <div className="md:col-span-2">
//               <button
//                 type="submit"
//                 disabled={savingProfile}
//                 className="inline-flex items-center px-4 py-2 bg-gray-900 text-white rounded-md text-sm hover:bg-gray-800 disabled:opacity-50"
//               >
//                 <Save className="h-4 w-4 mr-2" />
//                 {savingProfile ? 'Saving…' : 'Save payroll profile'}
//               </button>
//             </div>
//           </form>

//           <div className="bg-white rounded-lg shadow p-6">
//             <h2 className="text-lg font-semibold text-gray-900">Generated payslips</h2>
//             <div className="overflow-x-auto mt-4">
//               <table className="min-w-full divide-y divide-gray-200 text-sm">
//                 <thead className="bg-gray-50">
//                   <tr>
//                     <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">
//                       Period
//                     </th>
//                     <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">
//                       Paid units
//                     </th>
//                     <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">
//                       Gross
//                     </th>
//                     <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">
//                       Net
//                     </th>
//                     <th className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase">
//                       PDF
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody className="divide-y">
//                   {payslips.map((p) => (
//                     <tr key={p._id}>
//                       <td className="px-4 py-2">
//                         {new Date(0, p.month - 1).toLocaleString('default', { month: 'long' })}{' '}
//                         {p.year}
//                       </td>
//                       <td className="px-4 py-2">{p.paidUnits}</td>
//                       <td className="px-4 py-2">
//                         ₹{Number(p.grossEarnings).toLocaleString('en-IN')}
//                       </td>
//                       <td className="px-4 py-2 font-medium">
//                         ₹{Number(p.netPay).toLocaleString('en-IN')}
//                       </td>
//                       <td className="px-4 py-2 text-right">
//                         <button
//                           type="button"
//                           onClick={() => downloadPdf(p._id)}
//                           className="text-primary-600 hover:text-primary-800 inline-flex items-center"
//                         >
//                           <Download className="h-4 w-4 mr-1" />
//                           Download
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//               {payslips.length === 0 && (
//                 <p className="text-gray-500 text-sm py-6 text-center">No payslips yet.</p>
//               )}
//             </div>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default PayrollEmployeeDetail;


import React, { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import {
  ArrowLeft,
  Download,
  FileText,
  GraduationCap,
  RefreshCw,
  Save,
  Sparkles,
  Wallet,
} from 'lucide-react';
import api from '../../services/api';
import {
  downloadBlob,
  filenameFromContentDisposition,
} from '../../utils/download';
import LoadingSpinner from '../common/LoadingSpinner';
import { toast } from 'react-toastify';

const defaultFilters = () => ({
  month: new Date().getMonth() + 1,
  year: new Date().getFullYear(),
});
const round2 = (x) => Math.round((Number(x) || 0) * 100) / 100;

/** Must match backend payrollCalculator ADDITIVE_EARNINGS — excluded from “core sum = attendance gross”. */
const ADDITIVE_EARNINGS_KEYS = ['bonus', 'mealAllowance'];

const PayrollEmployeeDetail = ({ basePath = '/admin/payroll' }) => {
  const { employeeId } = useParams();
  const [filters, setFilters] = useState(defaultFilters);
  const [summary, setSummary] = useState(null);
  const [payslips, setPayslips] = useState([]);
  const [loading, setLoading] = useState(true);
  const [savingProfile, setSavingProfile] = useState(false);
  const [generating, setGenerating] = useState(false);
  const [profileForm, setProfileForm] = useState({
    pan: '',
    uan: '',
    esiNumber: '',
    pfNumber: '',
    department: '',
    workLocation: '',
    bankName: '',
    bankAccountNumber: '',
    bankIfsc: '',
    pfContribution: true,
    esiApplicable: false,
    payslipTaxEmployeeNote: '',
  });
  const [splitForm, setSplitForm] = useState({
    earnings: {
      basic: 0,
      hra: 0,
      specialAllowance: 0,
      lta: 0,
      itAllowance: 0,
      mealAllowance: 0,
      bonus: 0,
    },
    deductions: {
      pfEmployee: 0,
      professionalTax: 0,
      esiEmployee: 0,
      incomeTax: 0,
      labourWelfareFund: 0,
    },
  });
  const [savingSplit, setSavingSplit] = useState(false);
  const [savingCompensation, setSavingCompensation] = useState(false);
  const [debugOpen, setDebugOpen] = useState(false);
  const [compensationForm, setCompensationForm] = useState({
    ctcBasic: 0,
    ctcHRA: 0,
    ctcSpecialAllowance: 0,
    ctcTravelAllowance: 0,
    ctcITAllowance: 0,
  });
  const [totalSalaryInput, setTotalSalaryInput] = useState('');

  const fetchSummary = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get(
        `/admin/payroll/employee/${employeeId}/summary?month=${filters.month}&year=${filters.year}`,
      );
      setSummary(res.data);
      const e = res.data.employee;
      if (e) {
        setCompensationForm({
          ctcBasic: Number(e.ctcBasic) || 0,
          ctcHRA: Number(e.ctcHRA) || 0,
          ctcSpecialAllowance: Number(e.ctcSpecialAllowance) || 0,
          ctcTravelAllowance: Number(e.ctcTravelAllowance) || 0,
          ctcITAllowance: Number(e.ctcITAllowance) || 0,
        });
      }
      const p = res.data.employee?.payrollProfile || {};
      setProfileForm({
        pan: p.pan || '',
        uan: p.uan || '',
        esiNumber: p.esiNumber || '',
        pfNumber: p.pfNumber || '',
        department: p.department || '',
        workLocation: p.workLocation || '',
        bankName: p.bankName || '',
        bankAccountNumber: p.bankAccountNumber || '',
        bankIfsc: p.bankIfsc || '',
        pfContribution: p.pfContribution !== false,
        esiApplicable: !!p.esiApplicable,
        payslipTaxEmployeeNote: p.payslipTaxEmployeeNote || '',
      });
      const c = res.data.calculation;
      if (c?.earnings && c?.deductions) {
        setSplitForm({
          earnings: {
            basic: Number(c.earnings.basic) || 0,
            hra: Number(c.earnings.hra) || 0,
            specialAllowance: Number(c.earnings.specialAllowance) || 0,
            lta: Number(c.earnings.lta) || 0,
            itAllowance:
              Number(c.earnings.itAllowance ?? c.earnings.telephoneInternet) || 0,
            mealAllowance: Number(c.earnings.mealAllowance) || 0,
            bonus: Number(c.earnings.bonus) || 0,
          },
          deductions: {
            pfEmployee: Number(c.deductions.pfEmployee) || 0,
            professionalTax: Number(c.deductions.professionalTax) || 0,
            esiEmployee: Number(c.deductions.esiEmployee) || 0,
            incomeTax: Number(c.deductions.incomeTax) || 0,
            labourWelfareFund: Number(c.deductions.labourWelfareFund) || 0,
            lopDeduction: Number(c.deductions.lopDeduction) || 0,
          },
        });
      }
    } catch (e) {
      console.error(e);
      toast.error(e.response?.data?.message || 'Failed to load payroll summary');
      setSummary(null);
    } finally {
      setLoading(false);
    }
  }, [employeeId, filters.month, filters.year]);

  const fetchPayslips = useCallback(async () => {
    try {
      const res = await api.get(`/admin/payroll/employee/${employeeId}/payslips`);
      setPayslips(res.data.payslips || []);
    } catch (e) {
      console.error(e);
    }
  }, [employeeId]);

  useEffect(() => {
    fetchSummary();
  }, [fetchSummary]);

  useEffect(() => {
    fetchPayslips();
  }, [fetchPayslips]);

  // const updateCompensation = (key, raw) => {
  //   const n = parseFloat(raw);
  //   setCompensationForm((prev) => ({
  //     ...prev,
  //     [key]: Number.isFinite(n) ? n : 0,
  //   }));
  // };

  const updateCompensation = (key, raw) => {
    const n = parseFloat(raw);
    const value = Number.isFinite(n) ? n : 0;
  
    setCompensationForm((prev) => {
      const next = { ...prev, [key]: value };
      const sum =
        (Number(next.ctcBasic) || 0) +
        (Number(next.ctcHRA) || 0) +
        (Number(next.ctcSpecialAllowance) || 0) +
        (Number(next.ctcTravelAllowance) || 0) +
        (Number(next.ctcITAllowance) || 0);
      setTotalSalaryInput(sum > 0 ? String(sum) : '');
      return next;
    });
  };
    /**
   * Splits a total salary figure into the CTC fields:
   * Basic = 50% of total, HRA = 50% of Basic, remainder split evenly
   * across Special allowance / Travel-LTA / IT allowance.
   * Fields stay individually editable afterward — this only sets initial values.
   */
    const distributeTotalSalary = (raw) => {
      setTotalSalaryInput(raw);
      const total = parseFloat(raw);
      if (!Number.isFinite(total) || total <= 0) return;
  
      const basic = round2(total * 0.5);
      const hra = round2(basic * 0.5);
      const specialAllowance = round2(total - basic - hra);
      // const each = round2(remaining / 3);
      // last field absorbs rounding drift so the three-way split still sums exactly
      // const itAllowance = round2(remaining - each * 2);
  
      setCompensationForm({
        ctcBasic: basic,
        ctcHRA: hra,
        ctcSpecialAllowance: specialAllowance,
        ctcTravelAllowance: 0,
        ctcITAllowance: 0,
      });

      // if (e) {
      //   const ctc = {
      //     ctcBasic: Number(e.ctcBasic) || 0,
      //     ctcHRA: Number(e.ctcHRA) || 0,
      //     ctcSpecialAllowance: Number(e.ctcSpecialAllowance) || 0,
      //     ctcTravelAllowance: Number(e.ctcTravelAllowance) || 0,
      //     ctcITAllowance: Number(e.ctcITAllowance) || 0,
      //   };
      //   setCompensationForm(ctc);
      //   const sum = ctc.ctcBasic + ctc.ctcHRA + ctc.ctcSpecialAllowance + ctc.ctcTravelAllowance + ctc.ctcITAllowance;
      //   setTotalSalaryInput(sum > 0 ? String(sum) : '');
      // }
    };

  const saveCompensation = async (e) => {
    e.preventDefault();
    setSavingCompensation(true);
    try {
      await api.put(`/admin/payroll/employee/${employeeId}/compensation`, compensationForm);
      try {
        await api.delete(
          `/admin/payroll/employee/${employeeId}/month-split?month=${filters.month}&year=${filters.year}`,
        );
      } catch (err) {
      }
      toast.success('Compensation & CTC saved');
      await fetchSummary();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Could not save compensation');
    } finally {
      setSavingCompensation(false);
    }
  };

  const saveProfile = async (e) => {
    e.preventDefault();
    setSavingProfile(true);
    try {
      await api.put(`/admin/payroll/employee/${employeeId}/profile`, profileForm);
      toast.success('Payroll profile saved');
      fetchSummary();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Save failed');
    } finally {
      setSavingProfile(false);
    }
  };

  const saveMonthSplit = async () => {
    setSavingSplit(true);
    try {
      const { arrears, ...earningsWithoutArrears } = splitForm.earnings;
      const { lopDeduction, professionalTax, ...deductionsForSave } = splitForm.deductions;
      await api.put(`/admin/payroll/employee/${employeeId}/month-split`, {
        month: filters.month,
        year: filters.year,
        earnings: earningsWithoutArrears,
        deductions: deductionsForSave,
      });
      toast.success('Earnings & deductions saved for this month');
      await fetchSummary();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Could not save split');
    } finally {
      setSavingSplit(false);
    }
  };

  const clearMonthSplit = async () => {
    try {
      await api.delete(
        `/admin/payroll/employee/${employeeId}/month-split?month=${filters.month}&year=${filters.year}`,
      );
      toast.success('Cleared saved split — defaults restored');
      await fetchSummary();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Could not clear');
    }
  };

  const updateEarning = (key, raw) => {
    const n = parseFloat(raw);
    setSplitForm((prev) => ({
      ...prev,
      earnings: { ...prev.earnings, [key]: Number.isFinite(n) ? n : 0 },
    }));
  };

  const updateDeduction = (key, raw) => {
    const n = parseFloat(raw);
    setSplitForm((prev) => ({
      ...prev,
      deductions: { ...prev.deductions, [key]: Number.isFinite(n) ? n : 0 },
    }));
  };

  // const generatePayslip = async () => {
  //   if (!earningsMatch) {
  //     toast.error(
  //       'Core earnings (basic, HRA, allowances — not bonus/meal) must match attendance gross. Fix the red row in Preview or use Refresh.',
  //     );
  //     return;
  //   }
  //   setGenerating(true);
  //   try {
  //     const { arrears: _omitArrears, ...earningsForSave } = splitForm.earnings;
  //     await api.put(`/admin/payroll/employee/${employeeId}/month-split`, {
  //       month: filters.month,
  //       year: filters.year,
  //       earnings: earningsForSave,
  //       deductions: splitForm.deductions,
  //     });
  //     await api.post(`/admin/payroll/employee/${employeeId}/generate`, {
  //       month: filters.month,
  //       year: filters.year,
  //     });
  //     toast.success('Month split saved and payslip generated');
  //     await fetchPayslips();
  //     await fetchSummary();
  //   } catch (err) {
  //     toast.error(err.response?.data?.message || 'Generation failed');
  //   } finally {
  //     setGenerating(false);
  //   }
  // };

  const generatePayslip = async () => {
    if (!earningsMatch) {
      toast.error(
        'Core earnings (basic, HRA, allowances — not bonus/meal) must match attendance gross. Fix the red row in Preview or use Refresh.',
      );
      return;
    }
    setGenerating(true);
    try {
      const { arrears: _omitArrears, ...earningsForSave } = splitForm.earnings;
      await api.put(`/admin/payroll/employee/${employeeId}/month-split`, {
        month: filters.month,
        year: filters.year,
        earnings: earningsForSave,
        deductions: splitForm.deductions,
      });
      const genRes = await api.post(`/admin/payroll/employee/${employeeId}/generate`, {
        month: filters.month,
        year: filters.year,
      });
      toast.success('Month split saved and payslip generated');
      await fetchPayslips();
      await fetchSummary();
  
      const newId = genRes?.data?.payslip?.id;
      if (newId) {
        await downloadPdf(newId); // opens the ZAN-style PDF right away
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Generation failed');
    } finally {
      setGenerating(false);
    }
  };

  const downloadPdf = async (payslipId) => {
    try {
      const res = await api.get(`/admin/payroll/payslip/${payslipId}/pdf-zan`, {
        responseType: 'blob',
      });
      const fname = filenameFromContentDisposition(
        res,
        `payslip_${payslipId}.pdf`,
      );
      downloadBlob(new Blob([res.data], { type: 'application/pdf' }), fname);
    } catch (err) {
      toast.error('Could not download PDF');
    }
  };

  const calc = summary?.calculation;
  const emp = summary?.employee;

  const earningsEntries = Object.entries(splitForm.earnings || {});
  const coreEarningsSum = earningsEntries.reduce((s, [k, v]) => {
    if (ADDITIVE_EARNINGS_KEYS.includes(k)) return s;
    return s + (Number(v) || 0);
  }, 0);
  const additiveEarningsSum = ADDITIVE_EARNINGS_KEYS.reduce(
    (s, k) => s + (Number(splitForm.earnings?.[k]) || 0),
    0,
  );
  const baseGross = Number(calc?.baseGrossEarnings) || Number(calc?.grossBeforeArrears) || 0;
  const autoArrears = Number(calc?.arrearsAmount) || Number(calc?.earnings?.arrears) || 0;
  const arrearsUnits = Number(calc?.arrearsUnits) || 0;
  const previewGrossTotal = baseGross + autoArrears + additiveEarningsSum;
  const earningsMatch = Math.abs(coreEarningsSum - baseGross) < 0.05;
  const deductionsSum = Object.values(splitForm.deductions || {}).reduce(
    (s, v) => s + (Number(v) || 0),
    0,
  );
  const previewNet = previewGrossTotal - deductionsSum;

  const monthlyCtcTotal =
    (Number(compensationForm.ctcBasic) || 0) +
    (Number(compensationForm.ctcHRA) || 0) +
    (Number(compensationForm.ctcSpecialAllowance) || 0) +
    (Number(compensationForm.ctcTravelAllowance) || 0) +
    (Number(compensationForm.ctcITAllowance) || 0);

  const ctcFields = [
    ['ctcBasic', 'Basic'],
    ['ctcHRA', 'HRA'],
    ['ctcSpecialAllowance', 'Other Allowances'],
    // ['ctcTravelAllowance', 'Travel / LTA'],
    // ['ctcITAllowance', 'IT allowance'],
  ];

  return (
    <div className="space-y-6 pb-8">
      <div className="flex items-center gap-3 pt-1">
        <Link
          to={basePath}
          className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-3.5 py-2 text-sm font-semibold text-primary-700 shadow-sm transition hover:-translate-x-0.5 hover:border-primary-200 hover:bg-primary-50"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to payroll list
        </Link>
      </div>

      {loading && !summary ? (
        <LoadingSpinner size="lg" className="py-16" />
      ) : !emp ? (
        <p className="text-gray-600">Employee not found.</p>
      ) : (
        <>
          <div className="relative isolate overflow-hidden rounded-3xl bg-gradient-to-br from-sky-400 via-cyan-500 to-blue-600 p-6 text-white shadow-xl shadow-sky-900/15 sm:p-8">
            <div className="absolute -right-16 -top-24 -z-10 h-72 w-72 rounded-full bg-white/25 blur-3xl" />
            <div className="absolute -bottom-32 left-1/3 -z-10 h-64 w-64 rounded-full bg-sky-200/25 blur-3xl" />
            <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
              <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl border border-white/25 bg-white/20 text-2xl font-bold shadow-lg shadow-sky-900/10 backdrop-blur-sm">
                {(emp.name || '?').charAt(0).toUpperCase()}
              </span>
              <div>
                <p className="mb-1 text-xs font-semibold uppercase tracking-[0.18em] text-sky-50/80">Employee payroll</p>
                <h1 className="text-2xl font-bold tracking-tight text-white drop-shadow-sm sm:text-3xl">{emp.name}</h1>
            <p className="mt-1 text-sm text-sky-50/90">
              {emp.jobTitle} · {emp.employeeId} · {emp.organization}
            </p>
            {emp.isIntern && (
              <p className="mt-2 inline-flex items-center gap-1.5 rounded-full border border-white/30 bg-white/20 px-3 py-1 text-xs font-semibold text-white backdrop-blur-sm">
                <GraduationCap className="h-3.5 w-3.5" />
                Intern — professional tax waived
                {emp.internshipEndDate
                  ? ` · ends ${new Date(emp.internshipEndDate).toLocaleDateString('en-IN')}`
                  : ''}
              </p>
            )}
              </div>
            </div>
          </div>

          <form
            onSubmit={saveCompensation}
            className="space-y-6 overflow-hidden rounded-3xl border border-slate-200 bg-white p-5 shadow-sm shadow-slate-200/60 sm:p-7"
          >
            <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4">
              <div className="flex gap-3">
                <div className="h-fit rounded-2xl bg-gradient-to-br from-primary-50 to-sky-100 p-3 text-primary-600 shadow-sm">
                  <Wallet className="h-6 w-6 text-primary-600" />
                </div>
                <div>
                  <h2 className="text-lg font-bold text-slate-900">Compensation &amp; CTC</h2>
                  <p className="mt-1 max-w-2xl text-sm leading-6 text-slate-500">
                    Monthly salary is the <strong>sum of CTC components</strong> below. Gross pay for the
                    selected month is that total × (paid work units ÷ working days in the month). Payslip
                    lines follow the same mix as your CTC (basic, HRA, etc.).
                  </p>
                </div>
              </div>
              <div className="shrink-0 rounded-2xl border border-sky-100 bg-gradient-to-br from-sky-50 to-primary-50 px-5 py-4 lg:text-right">
                <p className="text-xs font-bold uppercase tracking-wide text-slate-500">
                  Monthly CTC (sum of components)
                </p>
                <p className="mt-1 text-2xl font-bold tracking-tight text-slate-900 tabular-nums">
                  ₹{monthlyCtcTotal.toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                </p>
              </div>
            </div>

            <div className="max-w-sm rounded-2xl border border-slate-200 bg-slate-50/70 p-4">
              <label className="block text-sm font-bold text-slate-800">
                Total salary (auto-split)
              </label>
                <div className="relative mt-2">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-slate-400">
                  ₹
                </span>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  className="w-full rounded-xl border border-slate-200 bg-white py-2.5 pl-8 pr-3 text-sm shadow-sm outline-none transition focus:border-primary-400 focus:ring-4 focus:ring-primary-50"
                  value={totalSalaryInput}
                  onChange={(e) => distributeTotalSalary(e.target.value)}
                  placeholder="Enter total monthly salary"
                />
              </div>
              <p className="mt-2 text-xs leading-5 text-slate-500">
                Basic = 50% of total · HRA = 50% of Basic · remainder split evenly across
                Special allowance, Travel/LTA, and IT allowance. Fields below stay editable.
              </p>
            </div>

            

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
              {ctcFields.map(([key, label]) => (
                <div key={key}>
                  <label className="block text-sm font-semibold text-slate-700">{label}</label>
                  <div className="relative mt-2">
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-slate-400">
                      ₹
                    </span>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      className="w-full rounded-xl border border-slate-200 bg-slate-50/60 py-2.5 pl-8 pr-3 text-sm outline-none transition focus:border-primary-400 focus:bg-white focus:ring-4 focus:ring-primary-50"
                      value={compensationForm[key]}
                      onChange={(ev) => updateCompensation(key, ev.target.value)}
                    />
                  </div>
                </div>
              ))}
            </div>

            {calc != null && (
              <div className="rounded-2xl border border-sky-100 bg-gradient-to-r from-sky-50 to-cyan-50 p-4">
                <p className="text-sm font-bold text-slate-800">Preview for selected month</p>
                <p className="mt-1 text-xs leading-5 text-slate-600">
                  Implied daily rate (monthly CTC ÷ working days in that month):{' '}
                  <span className="font-semibold text-slate-900 tabular-nums">
                    ₹{Number(calc.payScalePerDay || 0).toLocaleString('en-IN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                  {' · '}
                  Gross before arrears:{' '}
                  <span className="font-semibold text-slate-900 tabular-nums">
                    ₹{Number(calc.grossBeforeArrears ?? 0).toLocaleString('en-IN', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </p>
              </div>
            )}

            <div className="flex justify-end border-t border-slate-100 pt-3">
              <button
                type="submit"
                disabled={savingCompensation}
                className="inline-flex w-full items-center justify-center rounded-xl bg-primary-600 px-5 py-2.5 text-sm font-bold text-white shadow-lg shadow-primary-600/20 transition hover:-translate-y-0.5 hover:bg-primary-700 disabled:opacity-50 md:w-auto"
              >
                <Save className="h-4 w-4 mr-2" />
                {savingCompensation ? 'Saving…' : 'Save compensation'}
              </button>
            </div>
          </form>

          <div className="rounded-3xl border border-slate-200 bg-white p-5 shadow-sm shadow-slate-200/60 sm:p-6">
            <div className="flex flex-col gap-4 md:flex-row md:flex-wrap md:items-end md:gap-4">
              <div className="w-full md:w-auto">
                <label className="block text-xs font-bold uppercase tracking-wide text-slate-500">Month</label>
                <select
                  value={filters.month}
                  onChange={(e) =>
                    setFilters((f) => ({ ...f, month: parseInt(e.target.value, 10) }))
                  }
                  className="mt-2 block w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2.5 text-sm outline-none transition focus:border-primary-400 focus:bg-white focus:ring-4 focus:ring-primary-50 md:w-40"
                >
                  {Array.from({ length: 12 }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      {new Date(0, i).toLocaleString('default', { month: 'long' })}
                    </option>
                  ))}
                </select>
              </div>

              <div className="flex items-end gap-2 md:contents">
                <div className="flex-1 md:flex-none">
                  <label className="block text-xs font-bold uppercase tracking-wide text-slate-500">Year</label>
                  <select
                    value={filters.year}
                    onChange={(e) =>
                      setFilters((f) => ({ ...f, year: parseInt(e.target.value, 10) }))
                    }
                    className="mt-2 block w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2.5 text-sm outline-none transition focus:border-primary-400 focus:bg-white focus:ring-4 focus:ring-primary-50 md:w-32"
                  >
                    {Array.from({ length: 6 }, (_, i) => {
                      const y = new Date().getFullYear() - 2 + i;
                      return (
                        <option key={y} value={y}>
                          {y}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <button
                  type="button"
                  onClick={fetchSummary}
                  className="inline-flex shrink-0 items-center justify-center rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-sm font-semibold text-slate-700 transition hover:border-primary-200 hover:bg-primary-50 md:px-4"
                >
                  <RefreshCw className="h-4 w-4 md:mr-2" />
                  <span className="hidden md:inline">Refresh</span>
                </button>
              </div>

              <button
                type="button"
                onClick={generatePayslip}
                disabled={generating}
                className="inline-flex w-full items-center justify-center rounded-xl bg-primary-600 px-4 py-2.5 text-sm font-bold text-white shadow-md shadow-primary-600/20 transition hover:-translate-y-0.5 hover:bg-primary-700 disabled:opacity-50 md:w-auto"
                title="Saves the current earnings & deductions split, then generates the payslip (bonus/meal are included)."
              >
                <Sparkles className="h-4 w-4 mr-2" />
                {generating ? 'Generating…' : 'Generate / update payslip'}
              </button>
              {summary?.existingPayslipId && (
                <button
                  type="button"
                  onClick={() => downloadPdf(summary.existingPayslipId)}
                  className="inline-flex w-full items-center justify-center rounded-xl bg-emerald-600 px-4 py-2.5 text-sm font-bold text-white shadow-md shadow-emerald-600/20 transition hover:-translate-y-0.5 hover:bg-emerald-700 md:w-auto"
                >
                  <Download className="h-4 w-4 mr-2" />
                  Download PDF (selected month)
                </button>
              )}
            </div>
          </div>

          {calc?.overrideWarning && (
            <div className="bg-red-50 border border-red-200 text-red-800 text-sm rounded-lg p-4">
              {calc.overrideWarning}
            </div>
          )}

          {calc && (
            <div className="space-y-6">
              {/* <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <div className="bg-white rounded-lg shadow p-6">
                  <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
                    <FileText className="h-5 w-5 text-primary-600" />
                    Attendance & pay calculation
                  </h2>
                  <dl className="mt-4 space-y-2 text-sm">
                    <div className="flex justify-between">
                      <dt className="text-gray-600">Monthly CTC</dt>
                      <dd className="font-medium">
                        ₹{monthlyCtcTotal.toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                      </dd>
                    </div>
                    <div className="flex justify-between">
                      <dt className="text-gray-600">Daily rate</dt>
                      <dd className="font-medium">
                        ₹{Number(calc.payScalePerDay || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </dd>
                    </div>
                    <div className="flex justify-between">
                      <dt className="text-gray-600">Days in month (rate basis)</dt>
                      <dd className="font-medium">{calc.effectiveWorkDays ?? '—'}</dd>
                    </div>
                    <div className="flex justify-between">
                      <dt className="text-gray-600">LOP days</dt>
                      <dd className="font-medium">{calc.lopDays ?? 0}</dd>
                    </div>
                    <div className="flex justify-between">
                      <dt className="text-gray-600">Paid day units</dt>
                      <dd className="font-medium">{calc.paidUnits}</dd>
                    </div>
                    <div className="flex justify-between">
                      <dt className="text-gray-600">Attendance Gross</dt>
                      <dd className="font-semibold text-gray-900">
                        ₹{Number(calc.baseGrossEarnings ?? calc.grossBeforeArrears ?? 0).toLocaleString('en-IN')}
                      </dd>
                    </div>
                    <div className="flex justify-between">
                      <dt className="text-gray-600">
                        Arrears (Auto)
                        {arrearsUnits > 0 && (
                          <span className="ml-1 text-xs text-gray-400">({arrearsUnits} prior-month unit{arrearsUnits !== 1 ? 's' : ''})</span>
                        )}
                      </dt>
                      <dd className="font-medium text-gray-900">
                        ₹{autoArrears.toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                      </dd>
                    </div>
                    {Number(autoArrears) > 0 && (
                      <div className="flex justify-between">
                        <dt className="text-gray-600">Total Gross (incl. arrears)</dt>
                        <dd className="font-semibold text-gray-900">
                          ₹{Number(calc.grossEarnings).toLocaleString('en-IN')}
                        </dd>
                      </div>
                    )}
                    <div className="flex justify-between">
                      <dt className="text-gray-600">Net (from split below)</dt>
                      <dd className="font-semibold text-primary-700">
                        ₹{Number(calc.netPay).toLocaleString('en-IN')}
                      </dd>
                    </div>
                    <div className="flex justify-between">
                      <dt className="text-gray-600">Gratuity (indicative)</dt>
                      <dd className="font-medium">
                        ₹{Number(calc.gratuityMonthlyAccrual).toLocaleString('en-IN')}
                      </dd>
                    </div>
                  </dl>
                  <div className="mt-4 pt-4 border-t text-xs text-gray-600 space-y-1">
                    <p>
                      Sundays: {calc.dayBreakdownSummary?.sundays} · Holidays:{' '}
                      {calc.dayBreakdownSummary?.holidays} · Working full:{' '}
                      {calc.dayBreakdownSummary?.fullPaidWorking} · Half:{' '}
                      {calc.dayBreakdownSummary?.halfPaidWorking}
                    </p>
                    <p>
                      Paid leave (full/half): {calc.dayBreakdownSummary?.leavePaidFull} /{' '}
                      {calc.dayBreakdownSummary?.leavePaidHalf} · LWP:{' '}
                      {calc.dayBreakdownSummary?.leaveWithoutPayFull} /{' '}
                      {calc.dayBreakdownSummary?.leaveWithoutPayHalf} · Absent:{' '}
                      {calc.dayBreakdownSummary?.absent}
                    </p>
                    <p>
                      Pre-join (unpaid): {calc.dayBreakdownSummary?.preJoin || 0} · Not yet worked:{' '}
                      {calc.dayBreakdownSummary?.future || 0}
                    </p>
                    {Number(calc.dayBreakdownSummary?.preJoin || 0) > 0 && (
                      <p className="text-amber-700">
                        This employee joined during this month or later, so only the days from
                        their first attendance are paid. Pre-join days are part of the LOP
                        deduction.
                      </p>
                    )}
                    <p>Comp Off paid (full/half): {calc.dayBreakdownSummary?.compOffPaidFull || 0} / {calc.dayBreakdownSummary?.compOffPaidHalf || 0}</p>
                  </div>
                </div>

                <div className="bg-white rounded-lg shadow p-6">
                  <h2 className="text-lg font-semibold text-gray-900">Preview</h2>
                  <p className="text-sm text-gray-600 mt-2">
                    Attendance gross:{' '}
                    <span className="font-mono">₹{baseGross.toLocaleString('en-IN')}</span>
                    {autoArrears > 0 && (
                      <>
                        {' · '}Arrears (auto):{' '}
                        <span className="font-mono">₹{autoArrears.toLocaleString('en-IN')}</span>
                      </>
                    )}
                    {additiveEarningsSum > 0 && (
                      <>
                        {' · '}Bonus / meal:{' '}
                        <span className="font-mono">₹{additiveEarningsSum.toLocaleString('en-IN')}</span>
                      </>
                    )}
                    {' · '}
                    <span className="font-semibold text-gray-900">
                      Preview gross: ₹{previewGrossTotal.toLocaleString('en-IN')}
                    </span>
                    .{' '}
                    {summary?.monthOverride && (
                      <span className="text-green-700 font-medium">Saved HR split for this month.</span>
                    )}
                  </p>
                  <dl className="mt-4 space-y-2 text-sm">
                    <div className="flex justify-between">
                      <dt className="text-gray-600">Core earnings (must match attendance gross)</dt>
                      <dd className={earningsMatch ? 'font-medium text-green-700' : 'font-medium text-red-600'}>
                        ₹{coreEarningsSum.toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                        {!earningsMatch && ` — need ₹${baseGross.toLocaleString('en-IN', { maximumFractionDigits: 2 })}`}
                      </dd>
                    </div>
                    {additiveEarningsSum > 0 && (
                      <div className="flex justify-between">
                        <dt className="text-gray-600">Bonus + meal (on top)</dt>
                        <dd className="font-medium text-gray-800">
                          ₹{additiveEarningsSum.toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                        </dd>
                      </div>
                    )}
                    <div className="flex justify-between">
                      <dt className="text-gray-600">Deductions total</dt>
                      <dd className="font-medium">₹{deductionsSum.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</dd>
                    </div>
                    <div className="flex justify-between border-t pt-2">
                      <dt className="text-gray-800 font-medium">Preview net (gross − deductions)</dt>
                      <dd className="font-semibold">₹{previewNet.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</dd>
                    </div>
                  </dl>
                  <p className="text-xs text-gray-500 mt-3">
                    Employer PF (ref.): ₹{Number(calc.employerPf).toLocaleString('en-IN')} · Employer ESI: ₹
                    {Number(calc.employerEsi).toLocaleString('en-IN')}
                  </p>
                </div>
              </div> */}

            <div className="rounded-3xl border border-slate-200 bg-white p-5 shadow-sm shadow-slate-200/60 sm:p-6">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-emerald-50 text-emerald-600">
                  <FileText className="h-5 w-5" />
                </span>
                <div>
                  <h2 className="text-lg font-bold text-slate-900">Preview</h2>
                  <p className="text-xs text-slate-500">Live payroll summary for the selected month</p>
                </div>
              </div>

              <div className="mt-5 space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-600">Attendance gross</span>
                  <span className="font-mono text-gray-900">₹{baseGross.toLocaleString('en-IN')}</span>
                </div>

                {autoArrears > 0 && (
                  <div className="flex justify-between">
                    <span className="text-gray-600">Arrears (auto)</span>
                    <span className="font-mono text-gray-900">₹{autoArrears.toLocaleString('en-IN')}</span>
                  </div>
                )}

                {additiveEarningsSum > 0 && (
                  <div className="flex justify-between">
                    <span className="text-gray-600">Bonus / meal</span>
                    <span className="font-mono text-gray-900">₹{additiveEarningsSum.toLocaleString('en-IN')}</span>
                  </div>
                )}

                <div className="mt-3 flex justify-between rounded-xl bg-sky-50 px-3 py-2.5">
                  <span className="font-semibold text-gray-900">Preview gross</span>
                  <span className="font-semibold text-gray-900">₹{previewGrossTotal.toLocaleString('en-IN')}</span>
                </div>

                {summary?.monthOverride && (
                  <p className="text-xs text-green-700 font-medium pt-0.5">
                    Saved HR split for this month.
                  </p>
                )}
              </div>

              <dl className="mt-5 space-y-2.5 border-t border-slate-100 pt-5 text-sm">
                <div className="flex justify-between">
                  <dt className="text-gray-600">Core earnings (must match attendance gross)</dt>
                  <dd className={earningsMatch ? 'font-medium text-green-700' : 'font-medium text-red-600'}>
                    ₹{coreEarningsSum.toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                    {!earningsMatch && ` — need ₹${baseGross.toLocaleString('en-IN', { maximumFractionDigits: 2 })}`}
                  </dd>
                </div>
                {additiveEarningsSum > 0 && (
                  <div className="flex justify-between">
                    <dt className="text-gray-600">Bonus + meal (on top)</dt>
                    <dd className="font-medium text-gray-800">
                      ₹{additiveEarningsSum.toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                    </dd>
                  </div>
                )}
                <div className="flex justify-between">
                  <dt className="text-gray-600">Deductions total + Professional Tax</dt>
                  <dd className="font-medium">₹{deductionsSum.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</dd>
                </div>
                {/* <div className="flex justify-between">
    
                        <dt className="text-gray-600">professional Tax</dt>
                          <dd className="font-medium">
                            ₹{Number(splitForm.deductions.professionalTax || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                          </dd>
                        
                </div> */}
                <div className="mt-3 flex justify-between rounded-xl bg-emerald-50 px-3 py-2.5">
                  <dt className="text-gray-800 font-medium">Preview net (gross − deductions)</dt>
                  <dd className="font-semibold">₹{previewNet.toLocaleString('en-IN', { maximumFractionDigits: 2 })}</dd>
                </div>
              </dl>

              <p className="text-xs text-gray-500 mt-3">
                Employer PF (ref.): ₹{Number(calc.employerPf).toLocaleString('en-IN')} · Employer ESI: ₹
                {Number(calc.employerEsi).toLocaleString('en-IN')}
              </p>
            </div>

              <div className="overflow-hidden rounded-3xl border border-slate-200 bg-white p-5 shadow-sm shadow-slate-200/60 sm:p-6">
                <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                  <h2 className="text-lg font-bold text-slate-900">
                    Earnings & deductions (editable for this month)
                  </h2>
                  <div className="flex flex-col sm:flex-row flex-wrap gap-2">
                    <button
                      type="button"
                      onClick={saveMonthSplit}
                      disabled={savingSplit || !earningsMatch}
                      className="inline-flex w-full items-center justify-center rounded-xl bg-primary-600 px-4 py-2.5 text-sm font-bold text-white shadow-md shadow-primary-600/20 transition hover:-translate-y-0.5 hover:bg-primary-700 disabled:opacity-50 sm:w-auto"
                    >
                      <Save className="h-4 w-4 mr-2" />
                      {savingSplit ? 'Saving…' : 'Save split'}
                    </button>
                    <button
                      type="button"
                      onClick={clearMonthSplit}
                      className="w-full rounded-xl border border-slate-200 px-4 py-2.5 text-sm font-semibold text-slate-700 transition hover:border-primary-200 hover:bg-primary-50 sm:w-auto"
                    >
                      Reset to auto
                    </button>
                  </div>
                </div>
                <p className="mt-2 text-xs leading-5 text-slate-500">
                  Basic, HRA, and other fixed allowances (above) must add up to the attendance gross. Bonus and meal
                  allowance are extra on top. Use <strong>Save split</strong> to store, or <strong>Generate payslip</strong>{' '}
                  to save and generate in one step.
                </p>
                <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-2">
                  <div>
                    <h3 className="mb-3 text-sm font-bold uppercase tracking-wide text-slate-600">Earnings</h3>
                    <div className="space-y-3">
                      {[
                        ['basic', 'Basic'],
                        ['hra', 'HRA'],
                        ['specialAllowance', 'Special allowance'],
                        ['lta', 'LTA'],
                        ['itAllowance', 'IT'],
                        ['mealAllowance', 'Meal allowance'],
                      ].map(([key, label]) => (
                        <div key={key} className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2">
                          <label className="text-sm text-gray-600 md:w-44 md:shrink-0">{label}</label>
                          <input
                            type="number"
                            step="0.01"
                            className="w-full rounded-xl border border-slate-200 bg-slate-50/60 px-3 py-2.5 text-sm outline-none transition focus:border-primary-400 focus:bg-white focus:ring-4 focus:ring-primary-50 md:flex-1"
                            value={splitForm.earnings[key]}
                            onChange={(e) => updateEarning(key, e.target.value)}
                          />
                        </div>
                      ))}
                      <div className="rounded-lg border border-amber-200 bg-amber-50/60 px-3 py-3 mt-4 space-y-2">
                        <div className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2">
                          <label className="text-sm font-medium text-amber-900 md:w-44 md:shrink-0">
                            Bonus
                          </label>
                          <input
                            type="number"
                            step="0.01"
                            className="w-full md:flex-1 border border-amber-200 rounded-md px-2 py-1.5 text-sm bg-white"
                            value={splitForm.earnings.bonus}
                            onChange={(e) => updateEarning('bonus', e.target.value)}
                          />
                        </div>
                        <p className="text-xs text-amber-900/80">
                          Variable by month — not part of fixed CTC split. Enter the amount that applies to this pay
                          period only.
                        </p>
                      </div>
                      <div className="rounded-lg border border-blue-200 bg-blue-50/60 px-3 py-3 mt-2 space-y-2">
                        <div className="flex items-center justify-between gap-2">
                          <div>
                            <span className="text-sm font-medium text-blue-900">Arrears (Auto)</span>
                            {arrearsUnits > 0 && (
                              <span className="ml-2 text-xs text-blue-700">{arrearsUnits} prior-month unit{arrearsUnits !== 1 ? 's' : ''}</span>
                            )}
                          </div>
                          <span className="text-sm font-semibold text-blue-900 tabular-nums">
                            ₹{autoArrears.toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                          </span>
                        </div>
                        <p className="text-xs text-blue-900/80">
                          Prior-month paid leaves approved this month — calculated automatically. Not editable.
                        </p>
                        {calc?.arrearsDetail?.explanation && (
                          <p className="text-xs text-blue-800 italic border-t border-blue-200 pt-2">
                            {calc.arrearsDetail.explanation}
                          </p>
                        )}
                        {calc?.arrearsDetail?.lateApprovedLeaves?.length > 0 && (
                          <details className="text-xs">
                            <summary className="cursor-pointer text-blue-700 font-medium select-none">
                              Audit trail ({calc.arrearsDetail.lateApprovedLeaves.length} leave record{calc.arrearsDetail.lateApprovedLeaves.length !== 1 ? 's' : ''})
                            </summary>
                            <ul className="mt-2 space-y-1 text-blue-900/80">
                              {calc.arrearsDetail.lateApprovedLeaves.map((l, i) => (
                                <li key={i} className="border-l-2 border-blue-300 pl-2">
                                  {l.dates} · {l.type} · {l.reason}
                                </li>
                              ))}
                            </ul>
                          </details>
                        )}
                      </div>
                    </div>
                  </div>
                  <div>
                    <h3 className="mb-3 text-sm font-bold uppercase tracking-wide text-slate-600">Deductions</h3>
                    <div className="space-y-3">
                      {[
                        ['pfEmployee', 'PF (employee)'],
                        ['professionalTax', 'Professional tax'],
                        ['esiEmployee', 'ESI (employee)'],
                        ['incomeTax', 'Income tax / TDS'],
                        ['labourWelfareFund', 'Labour welfare fund'],
                      ].map(([key, label]) => (
                        <div key={key} className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2">
                          <label className="text-sm text-gray-600 md:w-44 md:shrink-0">{label}</label>
                          <input
                            type="number"
                            step="0.01"
                            className="w-full rounded-xl border border-slate-200 bg-slate-50/60 px-3 py-2.5 text-sm outline-none transition focus:border-primary-400 focus:bg-white focus:ring-4 focus:ring-primary-50 md:flex-1"
                            value={splitForm.deductions[key]}
                            onChange={(e) => updateDeduction(key, e.target.value)}
                          />
                        </div>
                      ))}
                       <div className="rounded-lg border border-purple-200 bg-purple-50/60 px-3 py-3 mt-2 space-y-2">
                        <div className="flex items-center justify-between gap-2">
                          <span className="text-sm font-medium text-purple-900">Professional Tax</span>
                          <span className="text-sm font-semibold text-purple-900 tabular-nums">
                            ₹{Number(splitForm.deductions.professionalTax || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                          </span>
                        </div>
                        <p className="text-xs text-purple-900/80">
                          {emp.isIntern
                            ? 'Waived for interns — the ₹200 flat professional tax is not deducted until HR confirms the internship.'
                            : 'Compulsory flat ₹200/month from August 2026 onward (₹0 for any month before that). Applied automatically. Not editable.'}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {process.env.NODE_ENV !== 'production' && calc.debug && (
                <div className="bg-white rounded-lg shadow border border-dashed border-yellow-300 p-6">
                  <button
                    type="button"
                    onClick={() => setDebugOpen((o) => !o)}
                    className="flex items-center gap-2 text-sm font-semibold text-yellow-800 hover:text-yellow-900"
                  >
                    <span>{debugOpen ? '▾' : '▸'}</span>
                    Payroll Debug (non-production only)
                  </button>
                  {debugOpen && (
                    <dl className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2 text-xs font-mono">
                      {Object.entries(calc.debug).map(([k, v]) => (
                        <div key={k} className="flex justify-between gap-2 border-b border-yellow-100 pb-1">
                          <dt className="text-yellow-900 truncate">{k}</dt>
                          <dd className="text-yellow-800 font-semibold shrink-0">
                            {typeof v === 'object' ? JSON.stringify(v) : String(v ?? '—')}
                          </dd>
                        </div>
                      ))}
                    </dl>
                  )}
                </div>
              )}
            </div>
          )}

          <form
            onSubmit={saveProfile}
            className="grid grid-cols-1 gap-5 rounded-3xl border border-slate-200 bg-white p-5 shadow-sm shadow-slate-200/60 md:grid-cols-2 sm:p-6"
          >
            <div className="md:col-span-2 space-y-2">
              <h2 className="text-lg font-bold text-slate-900">
                Payslip &amp; statutory details
              </h2>
              <p className="text-sm leading-6 text-slate-500">
                Pre-filled from the employee&apos;s{' '}
                <strong>onboarding record</strong> (PAN, PF reference, address city/state) and any{' '}
                <strong>payroll fields</strong> already saved. Adjust here only when something changed or was missing —
                saving updates both the payroll record and the employee profile where applicable.
              </p>
            </div>
            <div>
              <label className="block text-sm text-gray-700">Department</label>
              <input
                className="mt-2 w-full rounded-xl border border-slate-200 bg-slate-50/60 px-3 py-2.5 text-sm outline-none transition focus:border-primary-400 focus:bg-white focus:ring-4 focus:ring-primary-50"
                value={profileForm.department}
                onChange={(e) => setProfileForm({ ...profileForm, department: e.target.value })}
              />
            </div>
            <div>
              <label className="block text-sm text-gray-700">Work location</label>
              <input
                className="mt-2 w-full rounded-xl border border-slate-200 bg-slate-50/60 px-3 py-2.5 text-sm outline-none transition focus:border-primary-400 focus:bg-white focus:ring-4 focus:ring-primary-50"
                value={profileForm.workLocation}
                onChange={(e) => setProfileForm({ ...profileForm, workLocation: e.target.value })}
              />
            </div>
            <div>
              <label className="block text-sm text-gray-700">PAN</label>
              <input
                className="mt-2 w-full rounded-xl border border-slate-200 bg-slate-50/60 px-3 py-2.5 text-sm outline-none transition focus:border-primary-400 focus:bg-white focus:ring-4 focus:ring-primary-50"
                value={profileForm.pan}
                onChange={(e) => setProfileForm({ ...profileForm, pan: e.target.value })}
              />
            </div>
            <div>
              <label className="block text-sm text-gray-700">UAN (PF)</label>
              <input
                className="mt-2 w-full rounded-xl border border-slate-200 bg-slate-50/60 px-3 py-2.5 text-sm outline-none transition focus:border-primary-400 focus:bg-white focus:ring-4 focus:ring-primary-50"
                value={profileForm.uan}
                onChange={(e) => setProfileForm({ ...profileForm, uan: e.target.value })}
              />
            </div>
            <div>
              <label className="block text-sm text-gray-700">PF number</label>
              <input
                className="mt-2 w-full rounded-xl border border-slate-200 bg-slate-50/60 px-3 py-2.5 text-sm outline-none transition focus:border-primary-400 focus:bg-white focus:ring-4 focus:ring-primary-50"
                value={profileForm.pfNumber}
                onChange={(e) => setProfileForm({ ...profileForm, pfNumber: e.target.value })}
              />
            </div>
            <div>
              <label className="block text-sm text-gray-700">ESI number</label>
              <input
                className="mt-2 w-full rounded-xl border border-slate-200 bg-slate-50/60 px-3 py-2.5 text-sm outline-none transition focus:border-primary-400 focus:bg-white focus:ring-4 focus:ring-primary-50"
                value={profileForm.esiNumber}
                onChange={(e) => setProfileForm({ ...profileForm, esiNumber: e.target.value })}
              />
            </div>
            <div>
              <label className="block text-sm text-gray-700">Bank name</label>
              <input
                className="mt-2 w-full rounded-xl border border-slate-200 bg-slate-50/60 px-3 py-2.5 text-sm outline-none transition focus:border-primary-400 focus:bg-white focus:ring-4 focus:ring-primary-50"
                value={profileForm.bankName}
                onChange={(e) => setProfileForm({ ...profileForm, bankName: e.target.value })}
              />
            </div>
            <div>
              <label className="block text-sm text-gray-700">Account number</label>
              <input
                className="mt-2 w-full rounded-xl border border-slate-200 bg-slate-50/60 px-3 py-2.5 text-sm outline-none transition focus:border-primary-400 focus:bg-white focus:ring-4 focus:ring-primary-50"
                value={profileForm.bankAccountNumber}
                onChange={(e) =>
                  setProfileForm({ ...profileForm, bankAccountNumber: e.target.value })
                }
              />
            </div>
            <div>
              <label className="block text-sm text-gray-700">IFSC</label>
              <input
                className="mt-2 w-full rounded-xl border border-slate-200 bg-slate-50/60 px-3 py-2.5 text-sm outline-none transition focus:border-primary-400 focus:bg-white focus:ring-4 focus:ring-primary-50"
                value={profileForm.bankIfsc}
                onChange={(e) => setProfileForm({ ...profileForm, bankIfsc: e.target.value })}
              />
            </div>
            <div className="flex items-center gap-2 md:col-span-2">
              <input
                id="pf"
                type="checkbox"
                checked={profileForm.pfContribution}
                onChange={(e) =>
                  setProfileForm({ ...profileForm, pfContribution: e.target.checked })
                }
              />
              <label htmlFor="pf" className="text-sm text-gray-700">
                PF employee contribution applicable
              </label>
            </div>
            <div className="flex items-center gap-2 md:col-span-2">
              <input
                id="esi"
                type="checkbox"
                checked={profileForm.esiApplicable}
                onChange={(e) =>
                  setProfileForm({ ...profileForm, esiApplicable: e.target.checked })
                }
              />
              <label htmlFor="esi" className="text-sm text-gray-700">
                ESI applicable (gross ≤ ₹21,000 — system uses this flag)
              </label>
            </div>
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-700">
                Payslip tax-page note (this employee only)
              </label>
              <p className="text-xs text-gray-500 mt-1 mb-2">
                Shown on the second PDF page only if HR enables the company tax page and enters company-wide
                text there. Use for employee-specific tax instructions or references.
              </p>
              <textarea
                rows={3}
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
                placeholder="Optional — e.g. reference to declared regime or internal payroll case ID"
                value={profileForm.payslipTaxEmployeeNote}
                onChange={(e) =>
                  setProfileForm({ ...profileForm, payslipTaxEmployeeNote: e.target.value })
                }
              />
            </div>
            <div className="md:col-span-2">
              <button
                type="submit"
                disabled={savingProfile}
                className="inline-flex w-full items-center justify-center rounded-xl bg-slate-900 px-4 py-2.5 text-sm font-bold text-white shadow-md shadow-slate-900/15 transition hover:-translate-y-0.5 hover:bg-slate-800 disabled:opacity-50 md:w-auto"
              >
                <Save className="h-4 w-4 mr-2" />
                {savingProfile ? 'Saving…' : 'Save payroll profile'}
              </button>
            </div>
          </form>

          <div className="overflow-hidden rounded-3xl border border-slate-200 bg-white p-5 shadow-sm shadow-slate-200/60 sm:p-6">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-violet-50 text-violet-600">
                <Download className="h-5 w-5" />
              </span>
              <div>
                <h2 className="text-lg font-bold text-slate-900">Generated payslips</h2>
                <p className="text-xs text-slate-500">Download previously generated payroll documents</p>
              </div>
            </div>
            <div className="overflow-x-auto mt-4">
              <table className="min-w-full divide-y divide-slate-200 text-sm">
                <thead className="bg-slate-50/80">
                  <tr>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">
                      Period
                    </th>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">
                      Paid units
                    </th>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">
                      Gross
                    </th>
                    <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">
                      Net
                    </th>
                    <th className="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase">
                      PDF
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  {payslips.map((p) => (
                    <tr key={p._id} className="transition hover:bg-slate-50">
                      <td className="px-4 py-2">
                        {new Date(0, p.month - 1).toLocaleString('default', { month: 'long' })}{' '}
                        {p.year}
                      </td>
                      <td className="px-4 py-2">{p.paidUnits}</td>
                      <td className="px-4 py-2">
                        ₹{Number(p.grossEarnings).toLocaleString('en-IN')}
                      </td>
                      <td className="px-4 py-2 font-medium">
                        ₹{Number(p.netPay).toLocaleString('en-IN')}
                      </td>
                      <td className="px-4 py-2 text-right">
                        <button
                          type="button"
                          onClick={() => downloadPdf(p._id)}
                          className="inline-flex items-center rounded-lg px-2.5 py-1.5 font-semibold text-primary-700 transition hover:bg-primary-50 hover:text-primary-800"
                        >
                          <Download className="h-4 w-4 mr-1" />
                          Download
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {payslips.length === 0 && (
                <p className="text-gray-500 text-sm py-6 text-center">No payslips yet.</p>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PayrollEmployeeDetail;
